import { Injectable } from '@angular/core';
import {
  Column,
  ColumnType,
} from '../../../../SGRE-shared/models/tableConfiguration';
import { AccessRequestConstants } from '../../model/access-request.model';
import {
  AccessRequestDetails,
  legalEntityPendingRoles,
} from '../access-request.state';

@Injectable({
  providedIn: 'root',
})
export class AccessRequestEffectsService {
  
  createTableConfiguration(data: legalEntityPendingRoles[]): AccessRequestDetails {
    const nameFilter = this.getFilterData(data, AccessRequestConstants.CUSTOMER_NAME);
    const userNameFilter = this.getFilterData(data, AccessRequestConstants.CUSTOMER_EMAIL);
    const legalEntities = this.getFilterData(data, AccessRequestConstants.COMPANY);
    const companyFilter = this.getFilterData(data, AccessRequestConstants.LEGAL_ENTITY_NAME);

    const columnData = [
      {
        label: AccessRequestConstants.NAME,
        name: AccessRequestConstants.CUSTOMER_NAME,
        type: ColumnType.text,
        filter: true,
        filterOptions: nameFilter,
      },
      {
        label: AccessRequestConstants.USER_NAME,
        name: AccessRequestConstants.CUSTOMER_EMAIL,
        type: ColumnType.text,
        filter: true,
        filterOptions: userNameFilter,
      },
      {
        label: AccessRequestConstants.ACTION_LABEL,
        name: AccessRequestConstants.ACTION,
        type: ColumnType.removeAndReview,
      },
    ];
    const columnData1 = [
      {
        label: AccessRequestConstants.NAME,
        name: AccessRequestConstants.CUSTOMER_NAME,
        type: ColumnType.text,
        filter: true,
        filterOptions: nameFilter,
      },
      {
        label: AccessRequestConstants.USER_NAME,
        name: AccessRequestConstants.CUSTOMER_EMAIL,
        type: ColumnType.text,
        filter: true,
        filterOptions: userNameFilter,
      },
      {
        label: AccessRequestConstants.COMPANY_LABEL,
        name: AccessRequestConstants.COMPANY,
        type: ColumnType.text,
        filter: true,
        filterOptions: legalEntities,
      },
      {
        label: AccessRequestConstants.LEGAL_ENTITY,
        name: AccessRequestConstants.LEGAL_ENTITY_NAME,
        type: ColumnType.text,
        filter: true,
        filterOptions: companyFilter,
      },
      {
        label: AccessRequestConstants.ACTION_LABEL,
        name: AccessRequestConstants.ACTION,
        type: ColumnType.removeAndReview,
      },
    ];
    const sgreAdmin = columnData.map((item) => new Column(item));
    const customerAdmin = columnData1.map((item) => new Column(item));
    return {
      legalEntityPendingRoles: data,
      sgreAdmin,
      customerAdmin,
    } as AccessRequestDetails;
  }

  getFilterData(data: legalEntityPendingRoles[], filterKey: string): Record<string, string>[] {
    const filteredArray = data
      ?.filter((item) => item[filterKey] !== undefined)
      .map((item) => ({ [filterKey]: item[filterKey] }));
    return Array.from(new Set(filteredArray.map(item => JSON.stringify(item)))).map(item => JSON.parse(item)); // Ensure unique objects
  }
}
